/**
 * Returns color styles based on post status.
 * Returns inline-style-safe values (no Tailwind bg classes) so dark mode works.
 */
export const returnStatusColor = (status) => {
  const colors = {
    approved: {
      bg: 'rgba(45,212,191,0.18)',
      border: '#2DD4BF',
    },
    published: {
      bg: 'rgba(45,212,191,0.10)',
      border: '#2DD4BF',
    },
    pending: {
      bg: 'rgba(250,204,21,0.15)',
      border: '#FACC15',
    },
    draft: {
      bg: 'rgba(100,116,139,0.12)',
      border: '#64748B',
    },
    regenerating: {
      bg: 'rgba(99,102,241,0.12)',
      border: '#6366F1',
    },
  };

  const c = colors[status] || colors.draft;

  return {
    // className kept for tour selector compatibility; no bg class included
    className: 'border-l-4',
    backgroundColor: c.bg,
    borderColor: c.border,
  };
};
